module.exports = __webpack_public_path__ + "static/dis-0020ec2553df45b670ad6a07270cb216.gif";